import BrandTitleCard from './brandTitleCard.container';

export default BrandTitleCard;